import { useTranslation } from "react-i18next";
import { TriangleAlert } from "lucide-react";
import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { PanelContent } from "../../lib/panel/panel-content";
import { ReturnEmailActionConfigDto } from "../node-types";
import { PanelReturnEmailTemplate } from "./panel-return-email-template";

export function ReturnEmailActionNodePanel(
  props: NodePanelProps<ReturnEmailActionConfigDto>,
) {
  const { t } = useTranslation("trackoffice");

  return (
    <PanelContainer nodeProps={props}>
      <PanelReturnEmailTemplate />
      <PanelContent
        title={t("workflowsEditor.panels.emailRecipient.title")}
        description={t(
          "workflowsEditor.returnEmailNode.recipientNote",
          "Return workflow emails are always sent to the customer.",
        )}
      >
        <p className="text-xs font-semibold">
          {t("workflowsEditor.panels.emailRecipient.options.customer")}
        </p>
      </PanelContent>
      {/* No automatic anti-double-send guard (BAB-2847 cancelled): taking
          over an event with a workflow is the merchant's explicit choice,
          made through the default-email toggles. */}
      <div className="mx-2 flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-2.5 text-xs text-amber-700 dark:border-amber-900/50 dark:bg-amber-950/30 dark:text-amber-400">
        <TriangleAlert className="mt-0.5 size-3.5 shrink-0" />
        <span>
          {t(
            "workflowsEditor.returnEmailNode.doubleSendHint",
            "Remember to disable the matching default email in Notifications → Configuration, otherwise the customer will receive both the standard email and this workflow email.",
          )}
        </span>
      </div>
    </PanelContainer>
  );
}
